import { fExecuteAPI } from "../../Server/Apis";
import {
  Driver_Attribute_GETROW,
  Driver_Load_GETROW,
  Driver_Save_GETROW,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";

import { vRdxUserInfo, DriverRo } from "../../Redux/roStore";
import moment from "moment";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
 
// const { tax1, tax2 } = vRdxtax();
// const vRdxUserInfoObj = vRdxUserInfo();
// const { HeadObject } = LoadingReceipt();

export const ErrorMsg = {
  DriverCode: "",
  FirstName: "",
  MiddleName: "",
  LastName: "",
  Location: "",
  DOB: "",
  FullName: "",
  LicenseNo: "",
  IssueDate: "",
  ExpiryDate: "",
  LicenseType: "",
  Type: "",
  InActive: "",
  Nationality: "",
  SMSName: "",
  ContactNo: "",
  WMS: "",
};

export const GridDataColumnsWmsSiDetail_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "UId", headerName: "Code", width: 100 },
  { field: "FName", headerName: "FName", width: 100 },
  { field: "MName", headerName: "MName", width: 100 },
  { field: "LName", headerName: "LName", width: 100 },
  { field: "FullName", headerName: "FullName", width: 100 },
  { field: "NationalityName", headerName: "Nationality", width: 100 },
  { field: "DOB", headerName: "DOB", width: 100 , valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
},
{ field: "LicenseNo", headerName: "LicenseNo", width: 100 },
{ field: "IssueDate", headerName: "IssueDate", width: 100 , valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
},
{ field: "ExpiryDate", headerName: "ExpiryDate", width: 100 , valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
},
{ field: "LicenseType", headerName: "LicenseTypeName", width: 100 },
{ field: "Typ", headerName: "Type", width: 100 },
{ field: "InActive", headerName: "InActive", width: 100 },
{ field: "Location", headerName: "Location", width: 100 },
{ field: "Contact", headerName: "Contact", width: 100 },
{ field: "SMSName", headerName: "SMSName", width: 100 },
{ field: "WMS", headerName: "WMS", width: 100 },
  
];

const fKeyLoadingReceipt = (event) => {
  const form = document.getElementById("DriverHead");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fKeyLoadingReceiptContent = (event) => {
  const form = document.getElementById("DriverContent");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fValidationHead_Client = (vRdxHead, setErrorMsg) => {
  let iRes = true;

  if (
    vRdxHead.DriverCode === "" ||
    vRdxHead.DriverCode === null ||
    vRdxHead.DriverCode === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      DriverCode: "DriverCode should not be empty",
    }));
    fAlertToast("INFO", "DriverCode should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.FirstName === "" ||
    vRdxHead.FirstName === null ||
    vRdxHead.FirstName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      FirstName: "FirstName should not be empty",
    }));
    fAlertToast("INFO", "FirstName should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.LicenseNo === "" ||
    vRdxHead.LicenseNo === null ||
    vRdxHead.LicenseNo === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      LicenseNo: "LicenseNo should not be empty",
    }));
    fAlertToast("INFO", "LicenseNo should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.LicenseType === "" ||
    vRdxHead.LicenseType === null ||
    vRdxHead.LicenseType === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      LicenseType: "LicenseType should not be empty",
    }));
    fAlertToast("INFO", "LicenseType should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.Nationality === "" ||
    vRdxHead.Nationality === null ||
    vRdxHead.Nationality === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Nationality: "Nationality should not be empty",
    }));
    fAlertToast("INFO", "Nationality should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.SMSName === "" ||
    vRdxHead.SMSName === null ||
    vRdxHead.SMSName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      SMSName: "SMSName should not be empty",
    }));
    fAlertToast("INFO", "SMSName should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.ContactNo === "" ||
    vRdxHead.ContactNo === null ||
    vRdxHead.ContactNo === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      ContactNo: "ContactNo should not be empty",
    }));
    fAlertToast("INFO", "ContactNo should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.InActive === "" ||
    vRdxHead.InActive === null ||
    vRdxHead.InActive === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      InActive: "InActive should not be empty",
    }));
    fAlertToast("INFO", "InActive should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.WMS === "" ||
    vRdxHead.WMS === null ||
    vRdxHead.WMS === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      WMS: "WMS should not be empty",
    }));
    fAlertToast("INFO", "WMS should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.DOB === "" ||
    vRdxHead.DOB === null ||
    vRdxHead.DOB === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      DOB: "Enter valid date",
    }));
    fAlertToast("INFO", "Enter valid date for DOB");
    iRes = false;
  }

  let iDateExd = moment(vRdxHead.DOB).format("MM/DD/YYYY");
  if (
    vRdxHead.DOB == "Invalid Date" ||
    new Date(iDateExd) < new Date("01/01/1990")
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      DOB: "Date is invalid",
    }));
    fAlertToast("INFO", "DOB is invalid");
    iRes = false;
  }

  if (
    vRdxHead.IssueDate === "" ||
    vRdxHead.IssueDate === null ||
    vRdxHead.IssueDate === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      IssueDate: "Enter valid date",
    }));
    fAlertToast("INFO", "Enter valid IssueDate");
    iRes = false;
  }

  let iDateIssueDate = moment(vRdxHead.IssueDate).format("MM/DD/YYYY");
  if (
    vRdxHead.IssueDate == "Invalid Date" ||
    new Date(iDateIssueDate) < new Date("01/01/1990")
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      IssueDate: "Date is invalid",
    }));
    fAlertToast("INFO", "IssueDate is invalid");
    iRes = false;
  }

  if (
    vRdxHead.ExpiryDate === "" ||
    vRdxHead.ExpiryDate === null ||
    vRdxHead.ExpiryDate === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      ExpiryDate: "Enter valid date",
    }));
    fAlertToast("INFO", "Enter valid ExpiryDate");
    iRes = false;
  }

  let iDateExpiryDate = moment(vRdxHead.ExpiryDate).format("MM/DD/YYYY");
  if (
    vRdxHead.ExpiryDate == "Invalid Date" ||
    new Date(iDateExpiryDate) < new Date("01/01/1990")
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      ExpiryDate: "Date is invalid",
    }));
    fAlertToast("INFO", "ExpiryDate is invalid");
    iRes = false;
  }

  if (Date.parse(vRdxHead.ExpiryDate) < Date.parse(vRdxHead.IssueDate)) {
    setErrorMsg((obj) => ({
      ...obj,
      ExpiryDate: "Expiry date should be greater than issue date",
    }));
    fAlertToast("INFO", "Expiry date should be greater than issue date");
    iRes = false;
  }

  if (
    vRdxHead.LastName === "" ||
    vRdxHead.LastName === null ||
    vRdxHead.LastName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      LastName: "LastName should not be empty",
    }));
    fAlertToast("INFO", "LastName should not be empty");
    iRes = false;
  }

  return iRes;
};


const fLoad_Grid = async (setDetailGridData) => {
  let iSIDetailObj = {
    v_Typ: "A",
    v_Data: "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);
  const iSIDetailResult = await Driver_Load_GETROW(FinalObj);
  if (iSIDetailResult?.status == 200) {
    if (iSIDetailResult.data.ResultSet.length > 0) {
      let GridID = iSIDetailResult.data.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setDetailGridData(GridID);
    } else {
      setDetailGridData([]);
    }
  }
};

//HEAD LOADING API
// Api

//API SaveSIHead
const fSaveHead = async (fNewDetail) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = DriverRo();
  let vSaveSIHeadObj = {
    v_UId: HeadObject.DriverCode,
    v_FName: HeadObject.FirstName,
    v_MName: HeadObject.MiddleName,
    v_LName: HeadObject.LastName,
    v_FullName: HeadObject.FullName,
    v_Nationality: HeadObject.Nationality,
    v_DOB: HeadObject.DOB,
    v_LicenseNo: HeadObject.LicenseNo,
    v_IssueDate: HeadObject.IssueDate,
    v_ExpiryDate: HeadObject.ExpiryDate,
    v_LicenseType: HeadObject.LicenseType,
    v_Typ: HeadObject.Type,
    v_InActive: HeadObject.InActive,
    v_UserCd: vRdxUserInfoObj.UserID,
    v_Loc: HeadObject.Location,
    v_Contact: HeadObject.ContactNo,
    v_SMSName: HeadObject.SMSName,
    v_WMS: HeadObject.WMS,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

  const vSaveSIHead = await Driver_Save_GETROW(FinalObj);
  if (vSaveSIHead?.status === 200) {
    // eslint-disable-next-line eqeqeq

    fNewDetail();
    fAlertToast("SUCCESS", "Successfully Saved");
  }
};

export const GetAttributes = async (setAttribute) => {
  const iAttributes = await Driver_Attribute_GETROW({});
  if (iAttributes?.status === 200) {
    setAttribute(iAttributes?.data?.ResultSet);

    return iAttributes?.data?.ResultSet;
  } else {
    setAttribute({
      Location: [],
      LicenseType: [],
      Type: [],
      Nationality: [],
    });
    return [];
  }
};

export {
  // rows,
  // columns,
  fKeyLoadingReceipt,
  fKeyLoadingReceiptContent,
  //save
  fValidationHead_Client,
  fLoad_Grid,
  fSaveHead,
};
